<template>
  <kst-page-export-details
    @init="handleInit"
    @export="handleExport"
  >
    <Export
      :userData="userData"
      @init="handleExport_init"
    />

    <kst-check disabled
      v-model="userData.WithDetails"
      :label="Info.Export.Details.Excel.Option.Details"
    />
    <kst-check v-if="access.Debt_Act_List"
      v-model="userData.WithDebtList"
      :label="Info.Export.Details.Excel.Option.DebtList"
    />
  </kst-page-export-details>
</template>

<script>
import Info from "../VenInfo.js";
import Model from "../VenModel.js";
import Services from "../../../services/Api/VendorService.js";

import Export from "./VenExD_Details.vue";

export default {
  components: {
    Export
  },
  data: () => ({
    Info: Info,
    Model: Model,
    userData: {
      ID: null,
      WithDetails: true,
      WithDebtList: true
    },
    access: {},
    // func
    exportExcelFunc: null
  }),
  methods: {
    handleInit(id) {
      this.resetData();
      this.userData.ID = id;
    },

    handleExport(loadExport) {
      const options = this.getListOptions()
      const config = Services.getExportDetails(options);
      loadExport(config, this.handleExport_success);
    },
    handleExport_success(data, fileName) {
      this.exportExcelFunc(data, fileName);
    },

    /*** export ***/

    handleExport_init(exportExcel) {
      this.exportExcelFunc = exportExcel;
    },

    /*** custom ***/

    resetData() {
      this.access = this.$kst.Access.create(Model.Access);
      this.userData.ID = null;
      this.userData.WithDetails = true;
      this.userData.WithDebtList = this.access.Debt_Act_List;
    },

    getListOptions() {
      return {
        id: this.userData.ID,
        withdebtlist: this.$kst.Out.getBoolean(this.userData.WithDebtList)
      };
    },
  }
}
</script>